import React from "react";

// Read-only label/value pair used across the Profile and CRM info tabs
const ReadOnlyField = ({ label, value, optional = false }) => (
  <div className="mb-8">
    <p className="text-black-45 font-semibold text-xs">
      {label} {optional && <span className="text-black/45">(Optional)</span>}
    </p>
    <div className="mt-2">
      <p className="text-black-88 font-normal text-sm">{value || "--"}</p>
    </div>
  </div>
);

export default ReadOnlyField;
